import React, { useState, useMemo } from "react";
import { Menu, Card, Input } from "antd";
import styles from "./styles.module.scss";
import { Link } from "react-router-dom";
import debounce from "lodash/debounce";
import { FormattedMessage } from "react-intl";

export function GroupSearch({
  groups,
  fetchingGroups = false,
  siteLanguage,
  onItemClick,
}) {
  const [query, setQuery] = useState("");
  if (fetchingGroups) return <p>lOADING...</p>;
  let filteredGroups = groups;
  if (query !== "") {
    filteredGroups = groups.filter(
      (el) => el.name.toLowerCase().indexOf(query.toLowerCase()) > -1
    );
  }

  const menuItems = filteredGroups.map((item) => (
    <Menu.Item key={`/${siteLanguage || "en"}/groups/${item.uuid}`}>
      {item.name}
      <span style={{ float: "right" }}>{item.person_count}</span>
      <Link
        data-dfs-people-id={"main-menu-item-group"}
        to={`/${siteLanguage || "en"}/groups/${item.uuid}`}
      />
    </Menu.Item>
  ));

  return (
    <div className={styles.GroupSearch}>
      {groups.length > 10 && (
        <Input.Search
          allowClear
          onChange={(e) => {
            setQuery(e.target.value);
          }}
        />
      )}
      <p className={styles.PlaceHolders}>
        {fetchingGroups && (
          <span>
            <FormattedMessage
              defaultMessage={"Loading"}
              id={"App.Text.Loading"}
            />
            ...
          </span>
        )}
        {!fetchingGroups && filteredGroups.length === 0 && (
          <FormattedMessage
            defaultMessage={"No Groups Found"}
            id={"App.Text.NoGroupsFound"}
          />
        )}
      </p>
      <Menu
        onClick={onItemClick}
        style={{
          border: "none",
        }}
      >
        {menuItems}
      </Menu>
    </div>
  );
}
